import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing,
  typography,
  shape,
  palette
}) => ({
  filledStyle: {
    '& > div': {
      borderRadius: shape.borderRadius,
      backgroundColor: palette.grey[100],
    },

    '& input': {
      paddingTop: `${spacing(1.5)}px !important`,
      paddingBottom: `${spacing(1.5)}px !important`,
      fontSize: '13px !important'
    }
  },
  outlinedStyle: {
    '& input': {
      padding: `${spacing(1.5)}px ${spacing(1.75)}px`,
      fontSize: '13px !important'
    }
  }
}));